import styled from 'styled-components'
import tw from 'tailwind-styled-components'

interface StyledProps {
  $isActive?: boolean
  $isCollapsed?: boolean
}

export const MenuItemContainerStyled = styled.div<StyledProps>`
  display: flex;
  align-items: center;
  cursor: pointer;
  border-radius: 4px;
`

export const MenuItemContainer = tw(MenuItemContainerStyled)`
  text-white
`

export const ExpandedContentStyled = styled.div<StyledProps>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 8px 16px;
  border-radius: 4px;
`

export const ExpandedContent = styled(ExpandedContentStyled)`
  background-color: ${(p: StyledProps) => (p.$isActive ? '#343434' : '#1B1B1E')};
  transition: width 0.25s linear;
  width: 100%;

  &:hover {
    background-color: #343434;
  }
`

export const CollapsedContentStyled = styled.div<StyledProps>`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 12px;
  color: white;
  border-radius: 4px;
  height: 37px;
`

export const CollapsedContent = styled(CollapsedContentStyled)`
  background-color: ${(p: StyledProps) => (p.$isActive ? '#343434' : '#1B1B1E')};
  transition: width 0.25s linear;

  &:hover {
    background-color: #343434;
  }
`

export const IconLabelGroup = styled.div`
  display: flex;
  align-items: center;
  gap: 13px;
`

export const Label = styled.span`
  color: white;
  font-size: 14px;
  font-weight: 500;
`

export const Arrow = styled.span`
  color: white;
  font-size: 10px;
`

export const TextContainer = styled.div`
  white-space: nowrap;
  overflow: hidden;
`
